import Vue from "vue";
import Vuetify from "vuetify/lib";

import colors from "vuetify/lib/util/colors";
// yarn add @mdi/font
import "@mdi/font/css/materialdesignicons.css";
Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: colors.indigo.darken2,
        secondary: colors.grey.darken1,
        accent: colors.pink,
        error: colors.red.accent3,
      },
      dark: {
        primary: colors.indigo.darken2,
        secondary: colors.grey.darken1,
        accent: colors.pink,
        error: colors.red.accent3,
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FB8C00",
      },
    },
  },
});
